import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface CompetenciaPayload {
  descripcion: string;
  estado?: number;
}

/**
 * 🔹 Interface de respuesta
 */
export interface Competencia {
  id?: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

export interface CompetenciaResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class CompetenciaService {
  private readonly apiUrl = `${environment.apiUrl}/api/competencia`;

  constructor(private http: HttpClient) {}

  // Listar todas las competencias
  getAll(): Observable<Competencia[]> {
    return this.http.get<Competencia[]>(this.apiUrl, { withCredentials: true });
  }

  // Obtener por ID
  getById(id: number): Observable<Competencia> {
    return this.http.get<Competencia>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Crear nueva competencia
  create(payload: CompetenciaPayload): Observable<CompetenciaResponse> {
    return this.http.post<CompetenciaResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  // Actualizar competencia
  update(id: number, payload: Partial<CompetenciaPayload>): Observable<CompetenciaResponse> {
    return this.http.put<CompetenciaResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  // Eliminar competencia (DELETE)
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Inactivar competencia
  inactivar(id: number): Observable<CompetenciaResponse> {
    return this.http.put<CompetenciaResponse>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  // Activar competencia
  activar(id: number): Observable<CompetenciaResponse> {
    return this.http.put<CompetenciaResponse>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
  }
}
